module.exports = __webpack_public_path__ + "static/media/walk.05c86be7.png";